class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, suppressOpen = false) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const targetElement = document.getElementById(section.targetId || section.id);
      if (!targetElement) return;

      targetElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

      if (section.targetId === 'cart-notification-also') {
        targetElement.hidden = targetElement.innerHTML.trim() === '';
      }
    });

    if (this.header) this.header.reveal();
    // The notification stays closed only when the checkout popup ACTUALLY
    // opened (suppressOpen) — for that add the popup replaces it. When the
    // popup declines to open (nothing left to suggest) the notification shows
    // as usual, so an add-to-cart is never silent.
    if (!suppressOpen) this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-product',
        targetId: 'cart-notification-also',
        selector: `[id="cart-notification-also-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
